import { Gift, Camera, Sparkles, ShieldCheck, ArrowRight } from "lucide-react";
import { business } from "../data/business";

// PLACEHOLDER CONTENT — DO NOT SHIP IN PRODUCTION
// ───────────────────────────────────────────────
// The Weekend Combo discount, photo-pack price ($39), booking-protection
// fee ($9), and gift-card flow are PROPOSED features, not confirmed by the
// business. Render only behind DEMO_CONTENT until the operator confirms each
// program exists and the dollar amounts are correct.
const items = [
  {
    icon: Sparkles,
    label: "RAFT + STAY + EAT",
    title: "Weekend Combo",
    desc: "Middle Ocoee + Lodge night + Sugarloaf dinner — bundle and save 12%.",
    cta: "View combo",
    href: "/rafting?combo=weekend",
    accent: "gold" as const,
  },
  {
    icon: Camera,
    label: "ADD-ON",
    title: "Pro Photo Pack",
    desc: "30+ professional river photos delivered in HD within 24 hrs. $39 — add at checkout.",
    cta: "Add at booking",
    href: business.bookingBase,
    external: true,
    accent: "neutral" as const,
  },
  {
    icon: ShieldCheck,
    label: "OPTIONAL",
    title: "Booking Protection",
    desc: "Cancel for any reason up to 24 hrs before your trip. $9 per paddler — opt in at checkout.",
    cta: "Learn more",
    href: "/cancellation",
    accent: "neutral" as const,
  },
  {
    icon: Gift,
    label: "GIVE THE OCOEE",
    title: "Gift Cards",
    desc: "Any amount, any trip — never expires. Email delivery + a printable card for the wrapping.",
    cta: "Buy a gift card",
    href: "/contact?topic=gift-card",
    accent: "gold" as const,
  },
];

export function AddOns() {
  return (
    <section className="addons" aria-label="Combos and add-ons">
      <div className="addons-head">
        <span className="eye">MAKE IT BIGGER</span>
        <h2 className="h2">Combos &amp; add-ons</h2>
        <p className="body">
          Bundle the river with a place to crash and a hot meal — or wrap it
          all up as a gift. Add-ons opt in during checkout, no commitments now.
        </p>
      </div>
      <div className="addons-grid">
        {items.map(({ icon: Icon, label, title, desc, cta, href, external, accent }) => {
          const isExternal = !!external;
          return (
            <a
              key={title}
              className={`addon-card addon-${accent}`}
              href={href}
              target={isExternal ? "_blank" : undefined}
              rel={isExternal ? "noopener noreferrer" : undefined}
            >
              <span className="addon-icon" aria-hidden="true"><Icon /></span>
              <span className="addon-label">{label}</span>
              <h3 className="addon-title">{title}</h3>
              <p className="addon-desc">{desc}</p>
              <span className="addon-cta">{cta} <ArrowRight size={14} aria-hidden="true" /></span>
            </a>
          );
        })}
      </div>
    </section>
  );
}
